module.exports = __webpack_public_path__ + "static/media/36.aa8191f2.jpg";